const about = {
	'about.title': 'Hakkımızda',
	'about.content':
		'Kripto paralar finansal özgürlüğe ulaşmak için yeni fırsatlar yaratıyor. Kullanıcı tabanı ne kadar büyük olursa, ortaya çıkan dağıtık defter teknolojilerinin sağladığı rekabet avantajı da o kadar büyük olur. Fast Coin, kullanımı kolay bir değişim platformu aracılığıyla dijital varlıklarınızdan en iyi şekilde yararlanmanızı sağlayacak araçları sunar.',
	'about.title2': 'Avantajları',
	'about.title2.tips1': 'Maksimum değişim kolaylığı ve bir strateji seçme olanağı, karlı değişimler yapmanıza olanak tanır',
	'about.title2.tips2': 'Güvenli bir geri ödeme imkânı sunuyoruz. Hiçbir risk almazsınız ve komisyonunuzu hemen görebilirsiniz',
	'about.title2.tips3': 'Herhangi bir cihazda en hızlı şekilde otomatik olarak kullanabilirsiniz',
	'about.title3': 'Misyon',
	'about.title3.tips1': `Dijital varlıklar alanında güvenilir ve itibarlı ortağınız olmayı hedefleyen vizyon sahibi, uzun vadeli bir oyuncuyuz. Misyonumuz, pratik ve ölçeklenebilir çözümlerle değişim sürecini basitleştirerek kripto ekonomisinin sizin için çalışmasını sağlamaktır.`,
	'about.title4': 'Desteklenen para birimleri',
}

export default about
